import type { ReactNode } from 'react';
import type { ValueOf } from 'type-fest';

export const alignments = {
  center: 'center',
  left: 'left',
} as const;

export const appearances = {
  fixed: 'fixed',
  light: 'light',
} as const;

export type Segment = {
  id: string;
  label: string;
  slot: ReactNode;
};

export type View = {
  defaultSegmentId?: string;
  id: string;
  segments: Segment[];
};

export type ToggleConfig = {
  label: string;
  name: string;
  value: string;
};

type SegmentedSectionBase = {
  alignment?: ValueOf<typeof alignments>;
  appearance?: ValueOf<typeof appearances>;
  className?: string;
  description?: string;
  eyebrow?: string;
  title: string;
};

type SegmentedSectionWithSingleView = {
  toggle?: never;
  views: [View];
};

type SegmentedSectionWithTwoViews = {
  toggle: ToggleConfig;
  views: [View, View];
};

export type SegmentedSection = SegmentedSectionBase &
  (SegmentedSectionWithSingleView | SegmentedSectionWithTwoViews);
